import { observer } from 'mobx-react';
import useToken from './useToken';
import '../theme/main.scss';
import 'antd/dist/antd.css';
import { configure } from 'mobx';
import { useEffect, useState } from 'react';
import { SsoWrapper } from '../containers/SsoWrapper';
import ReactGA from 'react-ga';
import { ANALYTICS_TRACK_CODE } from '../analytics/analytics';
import ModalProvider from '../containers/MainWrapper/modal/ModalProvider';
import { AuthClient } from '@react-keycloak/core/lib/types';
import keycloakInstance from '../keycloak';
import { ReactKeycloakProvider } from '@react-keycloak/web';
import { ProjectManagementStore } from '../store/ProjectManagement';
import { UserStore } from '../store/User';
import { selectorsNames, defaultSelectorsResult } from '../store/ProjectManagement';

ReactGA.initialize(ANALYTICS_TRACK_CODE);

configure({
  enforceActions: 'never',
});


const Root = observer(() => {
  const { token, setToken } = useToken();
  const {getFeatureFlags, getFeatureSelectors} = ProjectManagementStore;
  const {roles, isProfileFetched, profile} = UserStore;
  const featuresNames = {
    SHOW_BUSINESS_TRIPS: true,
    SHOW_AI_ASSISTANT: false,
  };

  const getSelectorsInput = (userRoles: string[], profileHierarchyPath: string) => {
    return Object.fromEntries(selectorsNames.map(i => {
      switch(i) {
      case 'SHOW_AI_ASSISTANT_FOR_6_DEP':
        return [i, {hierarchy_path: profileHierarchyPath.slice(0, '1.1483'.length)}];
      case 'SHOW_AI_ASSISTANT_FOR_GDO':
        return [i, {hierarchy_path: profileHierarchyPath.slice(0, '1.1355'.length)}];
      case 'SHOW_WHO_IS_OFF_VERSION_3_FOR_AMC':
      case 'SHOW_WHO_IS_OFF_VERSION_3_FOR_AML':
      default:
        return [i, {roles: userRoles}];
      }
    }));
  }; 

  const [selectorsVariables, setSelectorsVariables] = useState(getSelectorsInput([], ''));

  useEffect(() => {
    getFeatureFlags(featuresNames);
  }, [featuresNames]);

  useEffect(() => {
    if (roles.fetched && isProfileFetched) {
      const newSelectors = getSelectorsInput(roles.values, profile.hierarchyPath);
      setSelectorsVariables(newSelectors);
    }
  },[roles.fetched, isProfileFetched]);

  useEffect(() => {
    getFeatureSelectors(selectorsVariables, defaultSelectorsResult);
  }, [selectorsVariables]);

  useEffect(() => {
    ReactGA.pageview(window.location.pathname + window.location.search);
  }, [window.location.pathname, window.location.search]);

  useEffect(() => {
    if(!token) {
      sessionStorage.removeItem('activePage');
    }
  },[token]);

  const onKeycloakTokens = (tokens: Pick<AuthClient, 'idToken' | 'refreshToken' | 'token'>) => {
    if(tokens.token){
      setToken(tokens.token);
    }
  };


  return (
    <div className="App" >
      <ReactKeycloakProvider initOptions={{
        checkLoginIframe: false,
        onLoad: 'login-required'
      }} 
      authClient={keycloakInstance}
      onTokens={onKeycloakTokens} 
      >
        <ModalProvider>
          <SsoWrapper/>
        </ModalProvider>
      </ReactKeycloakProvider>
    </div>
  );
});

export default Root;
